enum SignUpDriverAddressType {
  MAILING = "MAILING",
  STARTING = "STARTING",
}

export default SignUpDriverAddressType;
